import { auth0 } from '@auth0/quantum-tokens';
import { createQuantumTheme } from './create-quantum-theme';
import { createTheme } from './create-theme';
export var defaultTheme = createTheme();
export var defaultQuantumTheme = createQuantumTheme({
    tokens: auth0,
});
